import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { AxiosResponse } from 'axios';

import { httpModules } from '@app/helpers/http.module';
import { FeaturedURL, SellerImagesUrl } from '@app/constants/url.constants';

interface Supplier {
	topSupplier: number;
	supplierId: string;
	supplierName: string;
	supplierLogo: string;
	supplierImage: string;
	link: string;
}

interface SupplierCardProps {
	value: Supplier;
}

const SupplierCard: React.FC<SupplierCardProps> = (props: SupplierCardProps) => (
	<div className="featured-deals__card-wrapper">
		<Link
			className="featured-deals__card"
			to={props.value.link}
		>
			<img
				className="featured-deals__card__cover"
				src={props.value.supplierImage}
				alt=""
			/>
			<img
				className="featured-deals__card__logo"
				src={props.value.supplierLogo}
				alt=""
			/>
		</Link>
	</div>
);

export const SpecialOffers: React.FC = () => {
	const [suppliers, setSuppliers] = useState<Array<Supplier>>([]);
	useEffect(() => {
		httpModules
			.get<Array<Supplier>>('https://www.onlinevacationcenter.com/api/pages/v1/Suppliers')
			.then((response: AxiosResponse<Array<Supplier> | undefined>) => {
				const list = response.data ?? [];
				list.forEach((item: Supplier) => {
					item.link = `${FeaturedURL}${item.supplierId}&type=0,1&order.direction=1&order.tag=Price&page=1`;
					item.supplierImage = `${SellerImagesUrl}${item.supplierImage}`;
				});

				setSuppliers(list);
			})
			.catch((error) => {
				console.log(error);
			});
	}, []);

	return (
		<div className="featured-deals">
			<h1
				className="font-family_primary text-size_hard-large"
				style={{ textAlign: 'center' }}
			>
				<b className="text-header__primary">Featured</b>
				<i className="font-family_decorative font-weight_light text-header__highlight"> Cruise Lines</i>
			</h1>

			<div className="featured-deals__list">
				{
					suppliers.map((value) => <SupplierCard key={value.supplierId} value={value} />)
				}
			</div>
		</div>
	);
};
